"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var CardBox_1 = require("components/CardBox");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var EditWeatherModal_1 = require("./EditWeatherModal");
var WeatherAt_1 = require("./WeatherAt");
var mapStateToProps = function (_state) { return ({}); };
var mapDispatchToProps = function (_dispatch) { return ({}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('editModalType', 'setEditModalType', 'CLOSED'), react_router_dom_1.withRouter, recompose_1.pure);
exports.default = enhance(function (props) {
    var weatherCondition = [
        {
            value: 'sunny',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/sunny')
        },
        {
            value: 'clear',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/clear')
        },
        {
            value: 'partlycloudy',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/partlycloudy')
        },
        {
            value: 'cloudy',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/cloudy')
        },
        {
            value: 'drizzle',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/drizzle')
        },
        {
            value: 'rainy',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/rainy')
        },
        {
            value: 'sleet',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/sleet')
        },
        {
            value: 'snowing',
            label: (0, translation_1.getLocalization)('diaryEntryView/weatherCondition/snowing')
        }
    ];
    if (!props.currentEntry) {
        return React.createElement("div", null);
    }
    return (React.createElement(CardBox_1.CardBox, { title: "weather" },
        React.createElement(EditWeatherModal_1.default, { show: props.editModalType !== 'CLOSED' ? true : false, modalType: props.editModalType, weatherInfo: props.weatherInfo, currentEntry: props.currentEntry, isDisabled: props.isDisabled, closeModal: function () { return props.setEditModalType('CLOSED'); }, setWeatherInfo: props.setWeatherInfo, weatherCondition: weatherCondition }),
        React.createElement("div", { className: "card-wrapper-weather" },
            React.createElement("div", { className: "card-box-weather" },
                React.createElement("div", { className: "card-box-content-weather" },
                    React.createElement("div", { className: "card-box-weather-time" }, (0, translation_1.getLocalization)('diaryEntryView/weather/clockseven')),
                    React.createElement("br", null),
                    React.createElement(WeatherAt_1.WeatherAt7, { isEditable: !props.isMobile, isDisabled: props.isDisabled, weatherInfo: props.weatherInfo, setWeatherInfo: props.setWeatherInfo, weatherCondition: weatherCondition, menuPortalTarget: document.querySelector('body') }),
                    props.isMobile && (React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: "fa-pen" }), size: "large", className: "edit-button", disabled: props.isDisabled, onClick: function () { return props.setEditModalType('CLOCK7'); } }, (0, translation_1.getLocalization)('diaryEntryView/modal/edit'))))),
            React.createElement("div", { className: "card-box-weather" },
                React.createElement("div", { className: "card-box-content-weather" },
                    React.createElement("div", { className: "card-box-weather-time" }, (0, translation_1.getLocalization)('diaryEntryView/weather/clocktwelve')),
                    React.createElement("br", null),
                    React.createElement(WeatherAt_1.WeatherAt12, { isEditable: !props.isMobile, isDisabled: props.isDisabled, weatherInfo: props.weatherInfo, setWeatherInfo: props.setWeatherInfo, weatherCondition: weatherCondition, menuPortalTarget: document.querySelector('body') }),
                    props.isMobile && (React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: "fa-pen" }), size: "large", className: "edit-button", disabled: props.isDisabled, onClick: function () { return props.setEditModalType('CLOCK12'); } }, (0, translation_1.getLocalization)('diaryEntryView/modal/edit'))))))));
});
